export default __webpack_public_path__ + "static/media/register-icon.943e25cf.svg";